import { gql } from 'graphql-request'

export const QueryBlockLogos = gql`
  fragment FragmentBlockLogos on BlockLogosModelRecord {
    __typename
    id
    title
    logos {
      __typename
      id
      name
      svgIcon {
        url
      }
    }
    cta {
      ...FragmentNavigationItem
    }
  }
`
export const BlockLogos = {
  __typename: 'BlockLogos',
  fragmentName: 'FragmentBlockLogos',
  fragmentQuery: QueryBlockLogos,
  fragments: ['FragmentNavigationItem']
}
